import { render, staticRenderFns } from "./ModalSuporteConvenio.vue?vue&type=template&id=07d47000&scoped=true"
import script from "./ModalSuporteConvenio.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteConvenio.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteConvenio.vue?vue&type=style&index=0&id=07d47000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d47000",
  null
  
)

export default component.exports